export default __webpack_public_path__ + "static/media/ic_users_b.d6878497.svg";